import * as Colors from "../../globalStyles/environmentColors";

//test
export const body = {
    minHeight: "100vh",
    backgroundColor: Colors.background
};

export const behindNavBar = {
    height: "8vh"
};

export const bodyBelowNavBar = {
    height: "92vh",
    overflowY: "scroll",
    overflowX: "hidden"
};
